// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"63fe91b2","21":"f6e7fe87","97":"e68fda45","478":"e910efcf","599":"63fe91b2","907":"e68fda45"}[chunkId] + ".chunk.css";
};